const DESKTOP_BREAKPOINT = 1024;

const StickyHeader = {
  init: () => {
    const body = document.body;
    const drupalToolbarNav = document.getElementById('toolbar-bar') ?? null;
    const drupalToolbarTray = document.getElementById('toolbar-item-administration-tray') ?? null;

    const stickyHeaderElement = document.getElementById('sticky-header') ?? null;

    if (!stickyHeaderElement) {
      return;
    }

    let currentScrollPos = 0;
    let ticking = false;
    let prevScrollpos = window.scrollY;

    stickyHeaderElement.setAttribute('aria-hidden', 'false');

    let isDrupalToolbarOpen,
      isDrupalToolbarHorizontal,
      isDrupalToolbarHorizontalOpen,
      topOffset,
      sideOffset,
      isMobile;

    updateVariables();
    setBodyPaddingTop();

    const onScroll = (scrollPos) => {
      updateVariables();
      const { height: stickyHeaderHeight } = stickyHeaderElement.getBoundingClientRect();

      if (scrollPos >= stickyHeaderHeight) {
        const isHeaderVisible = prevScrollpos >= scrollPos;

        stickyHeaderElement.style.transform = isHeaderVisible
          ? `translateY(${topOffset}px)`
          : `translateY(${topOffset - stickyHeaderHeight}px)`;
        stickyHeaderElement.setAttribute('aria-hidden', `${isHeaderVisible ? 'false' : 'true'}`);
        stickyHeaderElement.parentElement.classList.remove('bg-white');

        if (drupalToolbarNav) {
          drupalToolbarNav.classList.add('hidden');
        }
      } else {
        stickyHeaderElement.parentElement.classList.add('bg-white');

        if (drupalToolbarNav) {
          drupalToolbarNav.classList.remove('hidden');
        }
      }

      prevScrollpos = scrollPos;
    };

    function handleScroll() {
      currentScrollPos = window.scrollY;

      if (!ticking) {
        requestAnimationFrame(() => {
          onScroll(currentScrollPos);
          ticking = false;
        });

        ticking = true;
      }
    }

    function updateVariables() {
      isMobile = body.clientWidth <= DESKTOP_BREAKPOINT;
      isDrupalToolbarOpen = !!drupalToolbarNav && body.classList.contains('toolbar-tray-open');
      isDrupalToolbarHorizontal =
        !!drupalToolbarNav && body.classList.contains('toolbar-horizontal');
      isDrupalToolbarHorizontalOpen = isDrupalToolbarOpen && isDrupalToolbarHorizontal;
      topOffset =
        isDrupalToolbarHorizontalOpen && !!drupalToolbarTray ? drupalToolbarTray.clientHeight : 0;
      sideOffset =
        !isMobile && isDrupalToolbarOpen && !isDrupalToolbarHorizontal
          ? drupalToolbarTray.clientWidth
          : 0;
    }

    function setBodyPaddingTop() {
      if (isDrupalToolbarHorizontalOpen) {
        body.style.setProperty(
          'padding-top',
          `${drupalToolbarNav.clientHeight + topOffset}px`,
          'important',
        );
      }
    }

    window.addEventListener('scroll', handleScroll);
  },
};

export default StickyHeader;
